import "./lib/domSafetyPatch";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/sentry"; // iter 250: error tracking (no-op se DSN assente)
import App from "@/App";

// iter 313 r21 v11 — Silenzia i cross-origin "Script error." event.
// Quando una libreria di terze parti (analytics, sentry, monitoring,
// service worker) lancia un errore in un contesto cross-origin, il
// browser maschera il messaggio come "Script error." per privacy. CRA
// dev overlay cattura questo evento e mostra un dialog rosso confondendo
// gli utenti beta. Catchiamo i `error` event vuoti e li sopprimiamo:
// gli errori veri (con message non-empty) passano normalmente.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const msg = (e?.message || "").trim();
      if (!msg || msg === "Script error." || msg === "Script error") {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
